import React from 'react';
import Logo from '../Logo/Logo';
import SmoothFdbkAnimation from '../AnimatedFdbk/AnimatedFdbk';
import HamburgerMenu from '../HamburgerMenu/HamburgerMenu';
import './header.css';
import { Link } from 'react-router-dom';

const Header = ({ hideLoginButton = false }) => {
  const user = localStorage.getItem('user');
  
  return (
    <header className="app-header">
      <SmoothFdbkAnimation />
      {user ? (
        <HamburgerMenu />
      ) : (
        !hideLoginButton && (
          <Link className='header-login-link' to="/">
            Login
          </Link>
        )
      )}
    </header>
  );
};

export default Header;